import { useEffect, useState } from 'react'
import Carousel from './Carousel'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import { GET_HOME_BANNER_LIST } from '~/graphqls/gqls'
import {
  getHomeBannerList,
  getHomeBannerListVariables,
  SystemCode,
  getCompetitionBanner_marketingModule_competitionBannerList,
} from '~/graphqls/types'
import { IAICompetitionContentObj } from '~/@types/ai'

/** 单个大赛详情 */
interface IAICompetitionDetailNode
  extends getCompetitionBanner_marketingModule_competitionBannerList,
    IAICompetitionContentObj {}

type Props = {
  children?: React.ReactNode
}
const BannerList = ({ children }: Props) => {
  const [bannerList, setBannerList] = useState<IAICompetitionDetailNode[]>([])

  const bannerAction = useImperativeQuery<
    getHomeBannerList,
    getHomeBannerListVariables
  >(GET_HOME_BANNER_LIST)

  const getData = async () => {
    try {
      const [bannerRes] = await Promise.all([
        bannerAction(
          {
            scene: 1,
          },
          {
            headers: {
              system_code: SystemCode.WUJIE_AI,
            },
          }
        ),
      ])

      const bannerList =
        bannerRes.data.marketingModule?.bannerList
          ?.map((it: any) => ({
            ...it,
            banner_cover: it.imageUrl,
            name: it.title,
            isBanner: true,
            startDateTime: it.startDateTime || -Infinity,
          }))
          .sort((a, b) => b.startDateTime - a.startDateTime)
          .sort((a, b) => b.sort - a.sort) || []

      setBannerList(bannerList.slice(0, 4))
    } catch (error) {}
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <div className="w-full h-[320px] relative flex items-center justify-center">
        <div className="absolute top-0 right-0 bottom-0 left-0">
          <Carousel
            list={bannerList.map((item: any) => {
              const [title, subTitle] = item.name!.split('：')
              return {
                img: (item.banner_cover || item.banner_pc)!,
                title,
                subTitle,
                id: item.id,
                redirectUrl: item.redirectUrl,
                isBanner: item.isBanner,
              }
            })}
          />
        </div>
        {children && (
          <div className="w-[694px] relative z-10 p-5">{children}</div>
        )}
      </div>
    </>
  )
}

export default BannerList
